module.exports = __webpack_public_path__ + "img/bg_pdf_cover.ba90cf9e.png";